import moment from 'moment';
import React, { useState } from 'react';
import { View } from 'react-native';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ImageIcon from '../../../components/shared/Icon/ImageIcon.component';
import { i18nService } from '../../../services/i18n.service';
import { CheckBox } from '../../EmplooyeeRequests/EmplooyeeRequests.utils';
import { hasPermissionOnBusinessUnit } from '../../../utils/globals.utils';
import { Privileges } from '../../../constants/roleTypes.constant';
import I18n from '../../../components/shared/i18n/I18n.component';

const convertMinutesToHours = (value: any, format?: string) => {
	if (value) {
		if (format !== 'DECIMAL') {
			const hours = `${Math.floor(value / 60)?.toLocaleString()}`;
			const minutes =
				value % 60 !== 0
					? value % 60 < 10
						? `0${value % 60}`
						: `${value % 60}`
					: '00';
			return `${hours}:${minutes}`;
		}
		return `${(value / 60).toLocaleString(undefined, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		})}`;
	}
	return '';
};

function ActionsCell({ row, onEdit, onShowHistory, canEditRow }: any) {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

	const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
		e.stopPropagation();
		setAnchorEl(e.currentTarget);
	};
	const handleClose = () => setAnchorEl(null);

	return (
		<div
			className='edit-cell-icon'
			style={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}
		>
			<div
				onClick={handleOpen}
				style={{ cursor: 'pointer', width: '100%', justifyContent: 'center', display: 'flex', alignItems: 'center' }}
			>
				<ImageIcon name='verticalDots' width={4} height={22} />
			</div>

			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				PaperProps={{ style: { borderRadius: 8, minWidth: 180 } }}
			>
				{canEditRow && (
					
					<MenuItem
						onClick={() => {
							onEdit(row.original);
							handleClose();
						}}
						style={{ borderBottom: '1px solid #E2EDF4', justifyContent: 'flex-end', gap: 16, paddingLeft: 16, paddingRight: 16, paddingTop: 10, paddingBottom: 10 }}
					>
						<I18n color='primaryDarkBlue'>{i18nService.translate('EmployeeHoursReport.table.edit')}</I18n>
						<ImageIcon name='editPencil' width={18} height={18} />
					</MenuItem>
				)}
					<MenuItem
						onClick={() => {
							onShowHistory(row.original);
							handleClose();
						}}
						style={{ justifyContent: 'flex-end', gap: 16, paddingLeft: 16, paddingRight: 16, paddingTop: 10, paddingBottom: 10 }}
					>
						<I18n color='primaryDarkBlue'>{i18nService.translate('EmployeeHoursReport.table.history')}</I18n>
						<ImageIcon name='history' width={18} height={18} />
					</MenuItem>
					
				
			</Menu>
		</div>
	);
}
export const convertFromUtc = (time: string, getHoursAndMinutes: boolean) => {
	if (!time) return null;
	const format = getHoursAndMinutes ? 'HH:mm' : "'YYYY-MM-DD HH:mm'";
	const utcTime = moment.utc(time, 'YYYY-MM-DDTHH:mm');
	const local = moment(utcTime).local().format(format);
	return local;
};
const headers = (
	total,
	onEdit: Function,
	onDelete: Function,
	onShowHistory: Function,
	worklogReportFormat,
	canEdit: boolean,
	businessUnitsList: any[],
) =>
	_.compact([
		{
			accessor: 'projectName',
			Header: i18nService.translate('EmployeeHoursReport.table.project'),
			isSortable: true,
			Footer: i18nService.translate('EmployeeHoursReport.table.total'),
		},
		{
			accessor: 'eventName',
			Header: i18nService.translate('EmployeeHoursReport.table.event'),
			isSortable: true,
		},
		businessUnitsList.length > 1
			? {
					accessor: 'businessUnitName',
					Header: i18nService.translate('general.businessUnits'),
					isSortable: true,
			  }
			: null,
		{
			accessor: 'workLogDate',
			Header: i18nService.translate('EmployeeHoursReport.table.date'),
			isSortable: true,
			CustomCell: ({ value, row }) =>
				value ? moment(value).format('DD/MM/YYYY') : '',
		},
		{
			accessor: 'enterTime',
			Header: i18nService.translate('EmployeeHoursReport.table.entry'),
			isSortable: true,
			CustomCell: ({ value, row }) => convertFromUtc(value, true),
		},
		{
			accessor: 'exitTime',
			Header: i18nService.translate('EmployeeHoursReport.table.exit'),
			isSortable: true,
			CustomCell: ({ value, row }) => convertFromUtc(value, true),
		},
		{
			accessor: 'lastUpdate',
			Header: i18nService.translate(
				'EmployeeHoursReport.table.lastUpdatedAt',
			),
			isSortable: true,
			CustomCell: ({ value, row }) =>
				value ? moment(value).format('DD/MM/YYYY') : '',
		},
		{
			accessor: 'total',
			Header: i18nService.translate('EmployeeHoursReport.table.total'),
			isSortable: true,
			CustomCell: ({ value, row }) =>
				convertMinutesToHours(value, worklogReportFormat),
			Footer: () =>
				` ${
					total
						? `(${(total / 60).toLocaleString(undefined, {
								minimumFractionDigits: 2,
								maximumFractionDigits: 2,
						  })})`
						: ''
				} ${convertMinutesToHours(total, 'HH:mm')} `,
		},
		{
			accessor: 'updatedBy',
			Header: i18nService.translate(
				'EmployeeHoursReport.table.updatedBy',
			),
			isSortable: true,
		},
		{
			accessor: 'updatedEnter',
			Header: i18nService.translate(
				'EmployeeHoursReport.table.manualEntry',
			),
			isSortable: true,
		},
		{
			accessor: 'updatedExit',
			Header: i18nService.translate(
				'EmployeeHoursReport.table.manualExit',
			),
			isSortable: true,
		},
		{
			accessor: 'updatedProject',
			Header: i18nService.translate(
				'EmployeeHoursReport.table.manualProjectChange',
			),
			isSortable: true,
		},
		{
			accessor: 'pendingStatus',
			Header: i18nService.translate(
				'EmployeeHoursReport.table.confirmStatus',
			),
			isSortable: true,
		},
		canEdit && {
			accessor: 'actions',
			Header: '',
			isSortable: false,
			CustomCell: ({ row }: any) => {
				const canEditRow = hasPermissionOnBusinessUnit(
					row.original.businessUnitId,
					Privileges.ROLE_LOG_WORK_REPORT_WRITE,
				);
				return (
					<ActionsCell
						row={row}
						onEdit={onEdit}
						onShowHistory={onShowHistory}
						canEditRow={canEditRow}
					/>
				);
			},
		},
	]);

const checkboxHeader = (
	isAllSelected: boolean,
	selectedRows: any[],
	onSelectAll: (cheacked: boolean) => {},
	onSelect: (index: any) => {},
) => {
	const shouldBeMarkedAsChecked = ({ workLogId }) => {
		if (isAllSelected) return true;
		if (selectedRows.includes(workLogId)) return true;
		return false;
	};
	return {
		accessor: 'checkbox',
		Header: () => (
			<CheckBox
				value={isAllSelected}
				onValueChange={(item: any) => {
					onSelectAll(item);
				}}
			/>
		),
		isSortable: false,
		CustomCell: ({ value, row }) =>
			row.original.pendingStatus === 'ממתין לאישור' &&
			hasPermissionOnBusinessUnit(
				row.original.businessUnitId,
				Privileges.ROLE_LOG_WORK_REPORT_WRITE,
			) ? (
				<CheckBox
					value={shouldBeMarkedAsChecked(row.original)}
					onValueChange={() => onSelect(row.original)}
				/>
			) : (
				<View />
			),
	};
};

export const Columns = (
	total: number,
	isSelectMode: boolean,
	selectedRows: any[],
	isAllSelected: boolean,
	onSelectAll: (cheacked: boolean) => {},
	onSelect: (index: any) => {},
	onDelete: Function,
	onShowHistory: Function,
	onEdit: Function,
	worklogReportFormat: any,
	canEdit: boolean,
	businessUnitsList: any[],
) => {
	return isSelectMode
		? [
				checkboxHeader(
					isAllSelected,
					selectedRows,
					onSelectAll,
					onSelect,
				),
				...headers(
					total,
					onEdit,
					onDelete,
					onShowHistory,
					worklogReportFormat,
					canEdit,
					businessUnitsList,
				),
		  ]
		: headers(
				total,
				onEdit,
				onDelete,
				onShowHistory,
				worklogReportFormat,
				canEdit,
				businessUnitsList,
		  );
};
